import { render, staticRenderFns } from "./categoryList.vue?vue&type=template&id=581a27dd&scoped=true&"
import script from "./categoryList.vue?vue&type=script&lang=js&"
export * from "./categoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581a27dd",
  null
  
)

export default component.exports